import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import './aws/awsConfig.js';
// DevExtreme: genau ein Thema (generic.light). Das bisherige Material-Thema src/css/bconn-webapp-theme.css bleibt als
// Rückweg im Repo, wird aber nicht mehr geladen.
import 'devextreme/dist/css/dx.light.css';
// Dunkelmodus: erzeugte Farbschicht (node scripts/dx-farbschicht.js) direkt nach dx.light.css. Ihre Regeln haben
// dieselbe Spezifität wie dort und ersetzen mit html.farbschema-dunkel dessen Farben; devextreme.css und alles Spätere
// schlagen sie wie dx.light.css (nach devextreme.css geladen, überschriebe sie dessen gleich spezifische Regeln).
import './css/redesign/devextreme-dunkel.css';
import 'leaflet/dist/leaflet.css';
import './plugins/devextreme';
import Dichte from './plugins/dichte';
import Ui from './plugins/ui';
// Redesign-CSS zuletzt (Seiten werden über den Router vorher importiert): CSS-Reihenfolge = Importreihenfolge
import './css/legacy-global.css';
import './css/redesign/tokens.css';
import './css/redesign/basis.css';
import './css/redesign/bedienelemente.css';
import './css/redesign/vuetify.css';
import './css/redesign/devextreme.css';
import './css/redesign/hub.css';
import axios from 'axios';
import { Auth } from "aws-amplify";
import moment from "moment";
import { shell } from './shell/shellState';
import { installGridWheel } from './utils/gridWheel';

moment.locale('de');

axios.interceptors.request.use(
  async config => {
    const token = (await Auth.currentSession()).getIdToken().getJwtToken();
    config.headers.authorization = token;
    return config;
  },
  error => Promise.reject(error)
);

// „Stand“ unten in der Navigation: Zeitpunkt der letzten erfolgreichen API-Antwort; Antwort und Fehler unverändert
// durchreichen
axios.interceptors.response.use(
  response => { shell.stand = new Date(); return response; },
  error => Promise.reject(error)
);

Vue.use(Dichte);
Vue.use(Ui);

// seitliches Scrollen mit Trackpad/Maus in allen Tabellen (DevExtreme scrollt simuliert nur senkrecht)
installGridWheel();

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
